import React, { Component, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import axios from 'axios';
import cookie from 'react-cookies';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import * as actions from '../../../../features/events/redux/actions';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import * as templateActions from '../../../../features/template/redux/actions';
import { getBuilderURL } from '../../../../common/utils/builder-url-util';
import RedirectRuleForm from './RedirectRuleForm';
import CustomLoader from '../../../common/CustomLoader';
import history from '../../../../common/history';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { pluginCode } from 'drapcode-constant';
import { getUserRoleFromApi } from '../../../../common/utils/item-util';

class ActionForm extends Component {
  state = {
    roles: {},
    isNewRoleRule: false,
    activeRole: '',
    allErrors: [],
    toggleMessages: false,
    isTwoFactorAuth: false,
  };

  componentDidMount() {
    const {
      projectId,
      version,
      actionData,
      events: { plugins },
    } = this.props;
    getUserRoleFromApi(projectId, version).then((res) => {
      this.setState({ roles: res });
    });
    const allErrors = actionData.args
      ? actionData.args.filter((arg) =>
        ['authErrorMessage', 'notFoundErrorMessage', 'othersErrorMessage'].includes(arg.name),
      )
      : [];
    const twoFactorAuthPlugin =
      plugins && plugins.find((e) => e.code === pluginCode.TWO_FACTOR_AUTHENTICATION);
    this.setState({ allErrors, isTwoFactorAuth: !!twoFactorAuthPlugin });
  }

  createSchemaForErrorFields = () => {
    const { allErrors } = this.state;
    const { eventAction } = this.props;
    let { parameters } = eventAction;
    const schema = {
      authErrorMessage: '',
      notFoundErrorMessage: '',
      othersErrorMessage: '',
    };
    allErrors.forEach((err) => {
      let errParams = parameters.find((param) => {
        return param.name === err.name;
      });
      if (errParams) schema[errParams.name] = errParams.value;
    });
    return schema;
  };

  getInitialValueRegisterTwoFactorAuthPage = () => {
    let registerTwoFactorAuthPage = '';
    let { parameters } = this.props.eventAction;
    let redirectRules = parameters.find((param) => {
      return param.name === 'redirectRules';
    });
    if (redirectRules) {
      let twoFactoAuthValue = redirectRules.value.find((val) => val.role === 'TWO_FACTOR_AUTH');
      if (twoFactoAuthValue)
        registerTwoFactorAuthPage = twoFactoAuthValue.registerTwoFactorAuthPage || '';
    }
    return registerTwoFactorAuthPage;
  };

  closeAllOpenPopup = (entityToCreate) => {
    const { projectId, version } = this.props;
    this.props.actions.closeActionFormModal();
    let token = cookie.load('token');
    if (!token) {
      token = '';
    }
    const redirectUrl = getBuilderURL();
    if (entityToCreate === 'page') {
      window.location.href = `${redirectUrl}editor/${version}/v/${projectId}/loader?open-modal=create-page&token=${token}`;
    } else {
      const {
        events: { collections },
      } = this.props;
      const roleCollection = collections.find((collection) => collection.collectionName === 'role');
      if (roleCollection) {
        history.push(
          `/2.0/collections/${version}/v/${projectId}/items/${roleCollection.uuid}/name/role`,
        );
      }
    }
  };

  closeRedirectRule = () => {
    this.setState({ isNewRoleRule: false });
  };

  handleRedirectUrls = (values) => {
    const { eventAction, actions, projectId, version, selectedEvent } = this.props;
    let redirectRules = eventAction.parameters.find((param) => {
      return param.name === 'redirectRules';
    });
    if (redirectRules) {
      let existingIndex = redirectRules.value.findIndex((rule) => rule.role === values.role);
      if (existingIndex < 0) {
        redirectRules.value = [...redirectRules.value, values];
      } else {
        redirectRules.value[existingIndex].page = values.page;
        redirectRules.value[existingIndex].successMessage = values.successMessage;
      }
    } else {
      redirectRules = { name: 'redirectRules', value: [values], type: 'array' };
      eventAction.parameters = [...eventAction.parameters, redirectRules];
    }
    console.log('eventAction', eventAction);
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: eventAction,
    });
  };
  deleteRule = (role) => {
    const { eventAction, actions, projectId, version, selectedEvent } = this.props;
    let redirectRules = eventAction.parameters.find((param) => {
      return param.name === 'redirectRules';
    });
    redirectRules.value = redirectRules.value.filter((rule) => rule.role !== role);
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: eventAction,
    });
  };

  activateRoles = (name) => {
    if (this.state.activeRole === name) {
      this.setState({ activeRole: '', isNewRoleRule: false });
    } else {
      this.setState({ activeRole: name, isNewRoleRule: true });
    }
  };

  showRoleRuleDetails = (roleRule) => {
    if (roleRule.role === 'TWO_FACTOR_AUTH') return '';
    return roleRule ? (
      <Fragment key={roleRule.role}>
        <Accordion allowZeroExpanded>
          <AccordionItem key={roleRule.role}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <i className="wb webconnect-person-fill"></i> <strong>{roleRule.role}</strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <RedirectRuleForm
                redirectRoleRule={roleRule}
                handleSubmit={this.handleRedirectUrls}
                roles={this.state.roles}
                events={this.props.events}
                closeAllOpenPopup={this.closeAllOpenPopup}
              >
                <div className="row">
                  <div className="col-12">
                    <div className="text-right">
                      <button
                        type="button"
                        className="btn btn-theme-delete btn-md"
                        onClick={() => this.deleteRule(roleRule.role)}
                      >
                        <i className="wb webconnect-trash-regular"></i> Delete
                      </button>
                      &nbsp;
                      <button type="submit" className="btn btn-theme-submit btn-md">
                        <i className="wb webconnect-save-regular"></i>&nbsp;Update
                      </button>
                    </div>
                  </div>
                </div>
              </RedirectRuleForm>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </Fragment>
    ) : (
      ''
    );
  };

  handleSubmit = (values) => {
    const { eventAction, actions, projectId, version, selectedEvent } = this.props;
    let { parameters } = eventAction;
    let redirectRules = parameters.find((param) => {
      return param.name === 'redirectRules';
    });
    let index = redirectRules.value.findIndex((val) => val.role === 'TWO_FACTOR_AUTH');
    let twoFactoAuthValue = '';
    if (index === -1) {
      redirectRules.value.push({ role: 'TWO_FACTOR_AUTH', ...values });
    } else {
      twoFactoAuthValue = { ...redirectRules.value[index], ...values };
      redirectRules.value[index] = twoFactoAuthValue;
    }
    console.log('eventAction', JSON.stringify(eventAction));

    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: eventAction,
    });
  };

  getPageOption = () => {
    let options = [];
    const { pages } = this.props.events;
    const pageOptions =
      pages.length > 0
        ? pages.map((item, key) => {
          return { value: '/' + item.slug, label: item.name };
        })
        : [];
    return [...options, ...pageOptions];
  };

  renderErrorFields = () => {
    const { allErrors } = this.state;
    return allErrors && allErrors.length
      ? allErrors.map((error) => (
        <div key={error.name} className="form-group">
          <FormFieldWithLabel
            cta={false}
            label={error.label}
            icon={error.type}
            infoIcon={true}
            infoDescription={error.infoDescription}
          >
            <Field
              name={error.name}
              type={error.type}
              placeholder={`(Optional) ${error.value}`}
              className="form-control form-control-sm"
            />
          </FormFieldWithLabel>
        </div>
      ))
      : '';
  };

  handleErrors = (values) => {
    const { eventAction, actions, projectId, version, selectedEvent } = this.props;
    const { allErrors } = this.state;
    let { parameters } = eventAction;

    allErrors.forEach((err) => {
      let errParams = parameters.find((param) => {
        return param.name === err.name;
      });
      if (errParams) {
        errParams.value = values[errParams.name];
      } else parameters.push({ name: err.name, type: 'text', value: values[err.name] });
    });
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: eventAction,
    });
  };

  render() {
    const { eventAction, actionData, show2AuthPage } = this.props;
    let redirectRules = eventAction.parameters.find((param) => {
      return param.name === 'redirectRules';
    });
    const { allErrors, isTwoFactorAuth } = this.state;

    return (
      <Fragment>
        {redirectRules && redirectRules.value && redirectRules.value.length > 0
          ? redirectRules.value.map((rule) => this.showRoleRuleDetails(rule))
          : ''}

        <Accordion allowZeroExpanded>
          <AccordionItem key={'newRole'}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <i className="wb webconnect-person-plus-fill"></i> <strong>New Role</strong>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <RedirectRuleForm
                redirectRoleRule={{ role: '', page: '' }}
                handleSubmit={this.handleRedirectUrls}
                roles={this.state.roles}
                events={this.props.events}
                closeAllOpenPopup={this.closeAllOpenPopup}
              >
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={() => {
                        this.activateRoles('New rule');
                        this.props.hideModal();
                      }}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button type="submit" className="btn btn-theme-submit btn-sm">
                      <i className="wb webconnect-save-regular"></i>&nbsp;Save
                      <CustomLoader loading={this.props.showLoaderForAction} />
                    </button>
                  </div>
                </div>
              </RedirectRuleForm>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
        {allErrors.length ? (
          <>
            <div className="m-2 col-md-12 text-right">
              <button
                onClick={(e) => this.setState({ toggleMessages: !this.state.toggleMessages })}
                className="btn btn-icon-only btn-outline-info ml-5 p-1"
                title="Show Advanced Options"
                type="button"
              >
                <i className="wb webconnect-cog"></i>&nbsp;Advanced Options
              </button>
            </div>
            {this.state.toggleMessages && (
              <Formik
                enableReinitialize={true}
                initialValues={this.createSchemaForErrorFields()}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  this.handleErrors(values);
                  setSubmitting(false);
                  resetForm();
                }}
              >
                {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
                  <Form className="mt-3">
                    <div className="row">
                      <div className="col-12">{this.renderErrorFields()}</div>
                    </div>
                    <div className="row">
                      <div className="col-md-12 text-right">
                        <button type="submit" className="btn btn-theme-submit btn-sm">
                          <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            )}
          </>
        ) : (
          ''
        )}
        {isTwoFactorAuth && show2AuthPage && (
          <Formik
            enableReinitialize={true}
            initialValues={{
              registerTwoFactorAuthPage: this.getInitialValueRegisterTwoFactorAuthPage(),
              verifyTwoFactorAuthPage: '',
            }}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              this.handleSubmit(values);
              setSubmitting(false);
              resetForm();
            }}
          >
            {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
              <Form className="mt-3">
                <CustomInputWithIcon
                  title="Redirect to page to register two factor authentication"
                  icon="select"
                  required={true}
                >
                  <CustomSelect
                    key="registerTwoFactorAuthPage"
                    name="registerTwoFactorAuthPage"
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={this.getPageOption()}
                    value={values['registerTwoFactorAuthPage']}
                    placeholder="Select Page"
                  />
                  <ErrorMessage name="registerTwoFactorAuthPage">
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </CustomInputWithIcon>
                <small style={{ paddingLeft: '13%' }}>
                  Choose a page where a user will verify two factor authentication
                </small>
                <div className="row">
                  <div className="col-md-6 text-left">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-sm"
                      onClick={this.props.hideModal}
                    >
                      <span>
                        <i className="wb webconnect-times"></i> Cancel
                      </span>
                    </button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button type="submit" className="btn btn-theme-submit btn-sm">
                      <i className="wb webconnect-save-regular"></i>&nbsp;Save Two Auth Config&nbsp;
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        )}
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
    template: state.template,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    templateActions: bindActionCreators({ ...templateActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActionForm);
